export default __webpack_public_path__ + "static/media/servingcheese.48e3e4bf.jpg";